import type { PublicSeatingDto, PublicTableCountDto } from '@lib/dto/public-schedule.dto'

/** "1 table", "12 tables". */
function count(n: number, one: string, many: string): string {
  return `${String(n)} ${n === 1 ? one : many}`
}

/** Whether a room has anything to seat: a table, or a chair. */
export function hasSeating(seating: PublicSeatingDto | null): seating is PublicSeatingDto {
  return seating !== null && (seating.tables.length > 0 || seating.chairsNotAtTable > 0)
}

/**
 * The room's seats in a line: every chair, at a table or in a row ("130
 * seats"), or "No seats" for a room of tables with no chairs. It gives no table
 * total, which would count buffet and cake tables with the guests' tables; the
 * rows say which are which.
 */
export function seatingHeadline(seating: PublicSeatingDto): string {
  let seats = seating.chairsNotAtTable
  for (const row of seating.tables) seats += row.tables * row.chairsEach
  return seats === 0 ? 'No seats' : count(seats, 'seat', 'seats')
}

/** "12 tables of 8", "1 table of 10", "2 tables, no chairs". */
export function tableCountLabel(row: PublicTableCountDto): string {
  const tables = count(row.tables, 'table', 'tables')
  return row.chairsEach === 0 ? `${tables}, no chairs` : `${tables} of ${String(row.chairsEach)}`
}

/** "24 chairs", "1 chair". */
export function chairCountLabel(chairs: number): string {
  return count(chairs, 'chair', 'chairs')
}
